/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tea_Package_SaveInputs */

const vi_tea_package_save = /** @type {(inputs: Tea_Package_SaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lưu`)
};

/**

* @param {Tea_Package_SaveInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const tea_package_save = /** @type {((inputs?: Tea_Package_SaveInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tea_Package_SaveInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_tea_package_save(inputs)
});